import * as yup from "yup"

export type UinRequest = {
    uin: string
    idCompany: number
}

export const uinRequest = yup.object().shape({
    uin: yup.string().required('Введите UIN').max(50, 'Максимальная длина 50 символов'),
    idCompany: yup.number().nullable().required('Выберите компанию').min(1, 'Выберите компанию'),
})